<template>
  <div class="container">
    <!-- Todo: move data to a store (e.g. Vuex) -->
    <Cart :data="data" />
    <MasterCardBanner />
    <!-- I can be convinced these don't need to be separated out to components. -->

    <section v-if="savedItems.length" class="saved-item container">
      <h2 class="saved-item-header">
        Saved for later
      </h2>
      <SavedItem
        v-for="savedItem in savedItems"
        :key="savedItem.id"
        :item="savedItem"
        @move-to-cart="moveToCart"
        @remove-from-saved="removeFromSaved"
      />
    </section>
  </div>
</template>

<script>
import mockData from "../../mockData.json";
import Cart from "../components/Cart.vue";
import MasterCardBanner from "../components/MasterCardBanner.vue";
import SavedItem from "../components/SavedItem.vue";

export default {
  name: "ShoppingCart",
  components: {
    Cart,
    MasterCardBanner,
    SavedItem,
  },
  data() {
    return {
      data: mockData,
    };
  },
  computed: {
    /*
    Returns the list of saved items if it exists.
    */
    savedItems() {
      // Would be nice to have the option to use optional chaining here MockData?.savedItems?.length()
      if (!this.data.savedItems) {
        return [];
      }
      return this.data.savedItems;
    },
    /*
    Returns the list of saved items if it exists.
    */
    cartQuantity() {
      return this.data.items.reduce(
        (subtotal, { quantity }) => subtotal + quantity,
        0
      );
    },
  },
  methods: {
    /*
    Moves samed item to the cart
    */
    moveToCart(itemId) {
      this.data.items.push(
        this.data.savedItems.find((item) => {
          return item.id === itemId;
        })
      );

      this.removeFromSaved(itemId);
    },
    /*
    Removes a samed item from the saved items list
    */
    removeFromSaved(itemId) {
      this.data.savedItems = this.data.savedItems.filter((item) => {
        return item.id !== itemId;
      });
    },
  },
  watch: {
    /*
    Update subtotal if cart quantity changes
    */
    cartQuantity() {
      this.data.subtotal = this.data.items.reduce(
        (subtotal, { price, quantity }) => subtotal + price * quantity,
        0
      );
    },
  },
};
</script>

<style lang="scss">
@import "../styles/globals/globals.scss";
* {
  box-sizing: border-box;
}

body {
  margin: 0;
}
</style>
